import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { shallowRef, watch } from 'vue'
import { useRoute } from 'vue-router'

import AppLayoutDefault from './AppLayoutDefault.vue'
import AppLayoutMain from './AppLayoutMain.vue'
import AppLayoutMainNew from './AppLayoutMainNew.vue'
import DevPanel from '@/components/DevPanel.vue'
import ESTBanner from '@/components/ESTBanner.vue'
import { getStateFeatureFlags } from '@/store/getters'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const route = useRoute()
const layout = shallowRef<
  | typeof AppLayoutDefault
  | typeof AppLayoutMain
  | typeof AppLayoutMainNew
  | undefined
>()

watch(
  () => route.meta,
  async (meta) => {
    if (route.fullPath === '/') {
      return
    }
    const mainLayout = getStateFeatureFlags()['ENABLE_NEW_LAYOUT']
      ? AppLayoutMainNew
      : AppLayoutMain
    layout.value = meta?.fullscreenLayout ? AppLayoutDefault : mainLayout
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (layout.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createVNode(DevPanel),
    _createVNode(ESTBanner)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})